import { Box } from '@mui/material';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { breadcrumbsActions } from '@store/breadcrumbs';
import GrafanaPanel from './GrafanaPanel';

export default function GrafanaDashboard({ title, url, breadcrumb }) {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      breadcrumbsActions.setBreadcrumbs([
        { label: 'Home', url: '/' },
        ...breadcrumb,
      ]),
    );
  }, [dispatch, title, url, breadcrumb]);

  const panelUrl = `${url}&theme=light&env=${process.env.REACT_APP_ENV}&js_file=${process.env.REACT_APP_URL}/grafana-cf/customize.js`;

  return (
    <Box style={{ position: 'relative', left: 0, top: 0 }}>
      <GrafanaPanel
        title={title}
        url={panelUrl}
      />
    </Box>
  );
}
